import { SportsQuickLinksWidget } from '@ps/web-sports-quick-links';

export default SportsQuickLinksWidget;
